import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const errormodule = {
	state: {
		errorCode : ''
	},
	getters: {
		getErrorCode: state => state.errorCode
	},
	actions: {
		eraseError({commit}){
			commit('eraseError')
		}
	},
	mutations: {
		setError(state, code){
			state.errorCode = code;
		},
		eraseError(state){
			state.errorCode = '';
		} 
	}
}

export default errormodule;


// WEBPACK FOOTER //
// ./src/store/errorModule.js